import { render } from "./PreloaderSpinner.vue?vue&type=template&id=2b1787db&scoped=true"
const script = {}

import "./PreloaderSpinner.vue?vue&type=style&index=0&id=2b1787db&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1787db"]])

export default __exports__